import React from 'react';
import { View } from 'react-native';

import { Txt } from './Txt';
import { theme } from 'lib/theme';
import { Icon, ICONS } from './Icon';

type PillProps = {
  label: string;
  withIcon: boolean;
  iconColor?: string;
  style?: React.ComponentProps<typeof View>['style'];
};

export const Pill: React.FC<PillProps> = ({
  label,
  withIcon = false,
  iconColor,
  style,
}) => (
  <View
    style={[
      {
        backgroundColor: theme.colors.black3,
        borderRadius: 99,
        alignItems: 'center',
        flexDirection: 'row',
        paddingVertical: theme.paddingVerticalQuarter / 2,
        paddingRight: theme.paddingVerticalHalf,
        paddingLeft: withIcon
          ? theme.paddingVerticalHalf / 2
          : theme.paddingVerticalHalf,
        gap: theme.paddingHorizontalHalf,
        minHeight: 24,
        maxWidth: '100%',
      },
      style,
    ]}
  >
    {withIcon && (
      <Icon
        source={ICONS.CircleSolid}
        color={iconColor || theme.colors.red}
        size={12}
      />
    )}
    <Txt size="xsmall" numberOfLines={1}>
      {label}
    </Txt>
  </View>
);
